import { io } from 'socket.io-client';
import router from "../router";

export default {
    namespaced: true,

    state: {
        socket: null,

        serverWillBeOff: false,
        serverWillBeOffNoteWasSeen: false,
        serverOffNoteWasSend: false,

        serverWasRestarted: false,
    },

    getters: {

    },

    mutations: {
        setSocket(state, sockets) {
            state.socket = sockets;
        },

        setServerWillBeOff(state, status) {
            state.serverWillBeOff = status;
        },

        setServerWillBeOffNoteWasSeen(state, status) {
            state.serverWillBeOffNoteWasSeen = status;
        },

        setServerOffNoteWasSend(state, status) {
            state.serverOffNoteWasSend = status;
        },

        setServerWasRestarted(state, status) {
            state.serverWasRestarted = status;
        },

    },

    actions: {
        connect({commit, dispatch}, {id, role}) {
            // WebSocket address
            const address = process.env.NODE_ENV === 'development' ? 'ws://localhost:3000' : undefined;

            // options use on the backend
            const options = {
                auth: { id, role }
            };

            // do auto socket.connect
            const socket = io(address, options);

            // recovered connection
            socket.once('msg-server-was-restarted', () => {
                commit('setServerWasRestarted', true);
            });

            // notify about the server will be off
            socket.once('msg-server-off-warning', () => {
                commit('setServerWillBeOff', true);
            });

            // save opened trim before the server will be off
            socket.once('save-current-trim', () => {
                const currentRoute = router.currentRoute.value.name;

                if (currentRoute === 'editor') {
                    dispatch('trims/saveTrimFromEditor', null, {root: true});
                }
            });

            // make global access to the socket
            commit('setSocket', socket);
        },

        disconnect({state}) {
            state.socket.disconnect();
        },

    }
}